import { styled } from 'styled-components';
import Flex from './Flex';

export const ContentContainer = styled(Flex)`
    margin: 0 auto;
    width: 100%;
    flex: 1;
    min-width: 55vw;
    max-width: 1500px;
`;
